var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Filter, Filters } from '@hn-ui/filters';
import { DropdownChecklist } from '@hn-ui/dropdowns';
import { styled } from 'styled-components';
var FilterContainer = styled.div.withConfig({ displayName: "FilterContainer", componentId: "sc-1mljz1o" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 32px;\n"], ["\n  margin-bottom: 32px;\n"])));
var GradeContainer = styled.div.withConfig({ displayName: "GradeContainer", componentId: "sc-1k04pew" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 16px;\n"], ["\n  margin-bottom: 16px;\n"])));
var PrintablesFilters = function (_a) {
    var grades = _a.grades, selectedGrade = _a.selectedGrade, onGradeChange = _a.onGradeChange, skillAndStandardsItems = _a.skillAndStandardsItems, selectedSkillsAndStandards = _a.selectedSkillsAndStandards, onSkillAndStandardSelect = _a.onSkillAndStandardSelect, rest = __rest(_a, ["grades", "selectedGrade", "onGradeChange", "skillAndStandardsItems", "selectedSkillsAndStandards", "onSkillAndStandardSelect"]);
    return (_jsxs(FilterContainer, __assign({ "data-testid": 'printables-filters' }, rest, { children: [_jsx(GradeContainer, { children: _jsx(Filters, __assign({ compact: true, onChange: onGradeChange, value: selectedGrade, "data-testid": 'filters' }, { children: grades.map(function (grade) { return (_jsx(Filter, { label: grade.data.shortName, value: String(grade.id) }, grade.id)); }) }), void 0) }, void 0), _jsx(DropdownChecklist, { placeholder: 'Type skill here', compact: true, searchable: true, items: skillAndStandardsItems, onChange: onSkillAndStandardSelect, selectedItems: selectedSkillsAndStandards, withTags: true, withClearAllTag: true, "data-testid": 'dropdown' }, void 0)] }), void 0));
};
export default PrintablesFilters;
var templateObject_1, templateObject_2;
